import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'

import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'

import {CopyToClipboard} from 'react-copy-to-clipboard'

import userSelectors from 'store/selectors/user'
import userActions from 'store/modules/user'
import snackbarActions from '@nocode-works/template/store/modules/snackbar'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(5),
  },
  dialogPaper: {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
  },
  button: {
    marginRight: theme.spacing(2),
  },
  tokenPre: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  tokenCode: {
    padding: theme.spacing(2),
    backgroundColor: '#cccccc',
    border: '1px solid #000',
  }
}))

const AccountSettings = ({

}) => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const accessToken = useSelector(userSelectors.accessToken)
  const onClearAccessToken = () => dispatch(userActions.setAccessToken(null))
  const onCopyToClipboard = () => dispatch(snackbarActions.setSuccess('Token copied to clipboard'))
  const onGenerateAccessToken = () => dispatch(userActions.generateAccessToken())

  return (
    <div className={ classes.root }>
      <Paper className={ classes.paper }>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Account Settings
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              <Button
                color="primary"
                variant="contained"
                onClick={ onGenerateAccessToken }
              >
                Generate Access Token
              </Button>
            </Typography>
          </Grid>
        </Grid>
      </Paper>
      <Dialog
        open={ accessToken ? true : false }
        onClose={ onClearAccessToken }
        fullWidth
        maxWidth="md"
        classes={{
          paper: classes.dialogPaper,
        }}
      >
        <DialogTitle>
          Your access token
        </DialogTitle>
        <DialogContent>
          <Typography>Your access token is shown below. <b>IMPORTANT</b> this is the only time you will see this token - keep it safe.</Typography>
          <Typography>Any previously generated tokens are now invalid.  You can regenerate your access token at any time.</Typography>
        </DialogContent>
        <DialogContent>
          <pre className={ classes.tokenPre }><code className={ classes.tokenCode }>{ accessToken ? accessToken.token : '' }</code></pre>
        </DialogContent>
        <DialogActions>
          <Button
            type="button"
            variant="contained"
            onClick={ onClearAccessToken }
          >
            Close
          </Button>
          <CopyToClipboard
            text={ accessToken ? accessToken.token : '' }
            onCopy={ onCopyToClipboard }
          >
            <Button
              type="button"
              color="secondary"
              variant="contained"
            >
              Copy to clipboard
            </Button>
          </CopyToClipboard>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default AccountSettings